import React from 'react';
import { Link } from 'react-router-dom';
import seoPages from '../data/seoPages.json';
import { SEO_CONFIG } from '../config/seo';
import MarketingLayout from './MarketingLayout';
import SEOHelmet from './SEOHelmet';
import './Guides.css';

const groups = ['Renovation guide', 'Handyman guide'];

export default function GuidesPage() {
  const itemList = seoPages.map((page, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: page.h1,
    url: `${SEO_CONFIG.siteUrl}/guides/${page.slug}`
  }));

  return <MarketingLayout>
    <SEOHelmet
      title="Maricopa Renovation & Handyman Guides | Local Advice"
      description="Explore 20 practical guides for remodeling, handyman work and home repairs in Maricopa, Arizona, from kitchens and bathrooms to drywall and punch lists."
      path="/guides"
      schema={[{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Maricopa Renovation and Handyman Guides',
        description: 'Practical planning resources for Maricopa homeowners.',
        url: `${SEO_CONFIG.siteUrl}/guides`,
        mainEntity: { '@type': 'ItemList', itemListElement: itemList }
      }]}
      breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Guides', path: '/guides' }]}
    />
    <section className="page-hero guide-hub-hero"><div className="page-width">
      <p className="breadcrumbs"><Link to="/">Home</Link> / Guides</p>
      <p className="eyebrow eyebrow-light">Local project knowledge</p>
      <h1 className="display-title">Renovation and handyman guides for Maricopa homes.</h1>
      <p className="section-copy">Twenty focused resources for making clearer decisions about remodeling, repair and the details that connect them.</p>
    </div></section>

    <section className="content-section"><div className="page-width guide-hub-intro">
      <div>
        <p className="eyebrow">Plan before work begins</p>
        <h2 className="section-title">Useful answers for projects large and small.</h2>
      </div>
      <div className="guide-prose">
        <p>A renovation question often starts with a product—new flooring, a shower, cabinets or countertops—but the result depends on preparation, measurements, sequencing and how each choice connects to the room around it. Our renovation guides help Maricopa homeowners build a more complete scope before comparing options.</p>
        <p>Handyman work benefits from the same clarity. Drywall damage, sticking doors, failed caulk and loose hardware may be isolated wear, or they may be evidence of a source that should be addressed first. The handyman guides explain what to document, how to group a punch list and when a project may need a licensed specialty trade or permit review.</p>
      </div>
    </div></section>

    {groups.map(group => <section className={`content-section guide-list-section ${group === 'Handyman guide' ? 'guide-list-alt' : ''}`} key={group}>
      <div className="page-width">
        <div className="section-head"><div><p className="eyebrow">{group}</p><h2 className="section-title">{group === 'Renovation guide' ? 'Plan the transformation.' : 'Take care of the details.'}</h2></div></div>
        <div className="guide-card-grid">
          {seoPages.filter(page => page.category === group).map(page => <Link className="guide-card" to={`/guides/${page.slug}`} key={page.slug}>
            <span className="guide-card-number">{String(seoPages.indexOf(page) + 1).padStart(2, '0')}</span>
            <span className="eyebrow">{page.category}</span>
            <h3>{page.h1}</h3>
            <p>{page.summary}</p>
            <span className="text-link">Read the guide</span>
          </Link>)}
        </div>
      </div>
    </section>)}

    <section className="cta-band"><div className="page-width"><h2>Have a real project behind the question?</h2><Link className="button button-light" to="/contact">Talk with our local team</Link></div></section>
  </MarketingLayout>;
}
